import { useState, useEffect } from 'react';
import { trustIndicators } from '@/mocks/homeData';

const carouselImages = [
  {
    src: '/images/fa1.jpg',
    alt: 'BA Fashionwear production floor',
  },
  {
    src: '/images/fa2.jpg',
    alt: 'Quality control laboratory',
  },
 
];

export default function Hero() {
  const [currentImage, setCurrentImage] = useState(0);
  const [prevImage, setPrevImage] = useState<number | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevImage(currentImage);
      setCurrentImage((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [currentImage]);

  const handleScroll = (targetId: string) => {
    const el = document.getElementById(targetId);
    if (el) {
      const navHeight = 80;
      const y = el.getBoundingClientRect().top + window.scrollY - navHeight;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex flex-col">
      <div className="relative flex-1 flex items-center min-h-[600px]">
        {/* Carousel background images */}
        <div className="absolute inset-0 z-0">
          {carouselImages.map((img, i) => (
            <img
              key={i}
              src={img.src}
              alt={img.alt}
              className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000 ease-in-out ${
                i === currentImage ? 'opacity-100' : 'opacity-0'
              }`}
            />
          ))}
          <div className="absolute inset-0 bg-gradient-to-b from-primary-900/75 via-primary-900/55 to-primary-900/70"></div>
        </div>

        {/* Carousel dots */}
        <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2.5">
          {carouselImages.map((_, i) => (
            <button
              key={i}
              onClick={() => {
                setPrevImage(currentImage);
                setCurrentImage(i);
              }}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                i === currentImage
                  ? 'bg-white w-6'
                  : 'bg-white/40 hover:bg-white/70'
              }`}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>

        <div className="relative z-10 w-full">
          <div className="section-container py-20 md:py-28 lg:py-32">
            <div className="max-w-[720px]">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-8 animate-on-scroll">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-white/90 text-xs font-medium tracking-wide uppercase">A Beaumonde Tex Ltd. Facility</span>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6 animate-on-scroll animate-on-scroll-delay-1">
                Precision Manufacturing.<br />
                <span className="text-accent-300">Trusted Global Partnership.</span>
              </h1>

              <p className="text-base md:text-lg text-white/75 leading-relaxed max-w-[580px] mb-10 animate-on-scroll animate-on-scroll-delay-2">
                Delivering premium knit and woven apparel with uncompromising quality, ethical manufacturing, and reliable supply chain performance.
              </p>

              <div className="flex flex-col sm:flex-row items-start gap-4 animate-on-scroll animate-on-scroll-delay-3">
                <a
                  href="#contact"
                  onClick={(e) => { e.preventDefault(); handleScroll('contact'); }}
                  className="inline-flex items-center px-8 py-3.5 bg-accent-400 text-primary-900 font-heading font-semibold text-sm rounded-md hover:bg-accent-300 transition-all duration-200 whitespace-nowrap"
                >
                  Request a Quote
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
                <a
                  href="#about"
                  onClick={(e) => { e.preventDefault(); handleScroll('about'); }}
                  className="inline-flex items-center px-8 py-3.5 border border-white/30 text-white font-heading font-semibold text-sm rounded-md hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
                >
                  Explore Our Factory
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 bg-white border-t border-[#E6EAF0]">
        <div className="section-container">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-[#E6EAF0]">
            {trustIndicators.map((item, i) => (
              <div key={i} className="flex items-center justify-center gap-2.5 py-5 px-3">
                <div className="w-7 h-7 flex items-center justify-center text-primary-500">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}